module.exports = __webpack_public_path__ + "img/Zain-Jordan-Ar-portrait.e03f666f.png";